<script>
import { apiORDSpost, apiEmailPDF } from '../shared/api-functions'
import apiPedido from '../api/api-pedido.js'

export default {
    props: {
        pedv: {type: Object}, 
    },

    data () {
        return {
            MESSAGE: false,
            foneToSend: null,
            newNumber: null,
            link: null,
            link_html: null,
            showModalNumber: false,
            showFormEmail: false, //exibe o formulario para envio de email
        }
    },

    mixins: [apiPedido],

    computed: {
        statusPedido: function () {
            return this.$store.getters.getPdstatusList.length > 0
        },

        linkECommerce: function () {
            if (this.$store.getters.getSessao.dominio) {
                const isHomolog = typeof window !== 'undefined' && window.location && (window.location.host.indexOf('teste') >= 0 || window.location.host.indexOf('localhost') >= 0);
                const sufixo = isHomolog ? '.teste.notabrasil.com.br' : '.notabrasil.com.br';
                return 'https://' + this.$store.getters.getSessao.dominio + sufixo + '/loja/#/pedido-concluido?uuid=';
            } else {
                return null;
            }
        },

    },

    methods: {
        handleCloseMessage () {
            this.MESSAGE = false;
            this.closeForm();
        },

        handleConfirmMessage () {
            window.open(this.link, "_blank"); 
            this.MESSAGE = false;
            this.closeForm();
        },

        async handleEnviaEmailECommerce () {
            var metodo = 'post'
            var modulo = 'sales/emailstatuspedido/'
            var sendData = { pedv: this.pedv.codpedv }
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data) {
                this.$scrollTo(0);
                this.$erpToastError(data);
            }else{
                this.$scrollTo(0);
                this.$erpToastSuccess('Email enviado.');
            }
            this.closeForm();
        },

        closeForm () {
            this.$emit('closeform')
        },

        handleEnviaLinkWhats(number){
            this.showModalNumber = false
            if (!number)
              return
            else
              this.apiEnviaPedidoWhats(this.pedv, number)
            this.closeForm()
        },

        handleLink (tipo) {
            if (this.pedv.ecommerce == 'S') {
                if (this.linkECommerce) {
                    this.link = this.linkECommerce + this.pedv.uuid
                    this.link_html = '<span class="badge badge-secondary" style="font-size: 18px;"><a style="color: white" :href="'+this.link+'" target="_blank">'+this.link+'</a></span>'
                    if (tipo == 'whats'){
                        this.showModalNumber = true
                    }else if (tipo == 'link'){
                        this.MESSAGE = true;
                    }else{
                        this.handleEnviaEmailECommerce()
                    }
                }else{
                    this.$erpToastError('Configure o Link de acesso nas configurações da Loja antes de executar essa operação.');
                }            
            } else {
                if (tipo == 'whats'){
                    this.showModalNumber = true
                }else if (tipo == 'link'){
                    this.MESSAGE = true;
                }else{
                    this.handleShowFormEmail()
                }
            }
        },

        handleShowFormEmail() {
            //Abre a tela para envio de email
            //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)
            this.showFormEmail = true
        },

        closeFormEmail() {
            this.showFormEmail = false
        },

        async handleSendEmail(data) {
            //cahamda para envio de email do pedido
            this.closeFormEmail()
            const email = await apiEmailPDF(this, 'pedv/' + this.pedv.codpedv, data)
            this.closeForm()
        },

    },

    watch: {

    },

    components: {

    },

    created () {
        //carrega lista de cadastro de status para selecao 
        this.$store.dispatch('loadPdstatus', {})
    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    }

}

</script>

<template>
    <div class="status-popover" style="position: absolute; width: 350px; top: 15px; left: 65px; padding: 15px;">
        <div class="row mb-2">
            <div class="col-12">
                Selecione a opção de compartilhamento
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-3 d-flex flex-wrap" style="gap: 8px">
                <v-button label="Exibir Link" 
                    v-if="pedv.ecommerce == 'S'" 
                    :success="true" 
                    icon="fa-external-link" 
                    @click="handleLink('link')"
                >
                </v-button>
                <v-button label="WhatsApp" :success="true" icon="fa-whatsapp" @click="handleLink('whats')"></v-button>
                <v-button 
                    label="E-mail" 
                    :success="true" 
                    icon="fa-envelope" 
                    v-if="pedv.ecommerce == 'S'" 
                    @click="handleLink('email')"
                >
                </v-button>                
                <v-button label="Cancelar"  @click="closeForm"></v-button>
            </div>
        </div>
        

        <!-- MENSAGEM -->
        <md-message v-if="MESSAGE" title="Link de status do Pedido" :message="link" @close="handleCloseMessage()" @confirm="handleConfirmMessage()" ></md-message>

        <!-- ENVIO DE EMAIL -->
        <email-form v-if="showFormEmail" :index="pedv.codpedv" tipo="PEDV" title="Envio de Pedido" @closeform="closeFormEmail" @send="handleSendEmail"></email-form>

        <!-- MODAL CONTATOS WHATSAPP -->        
        <fones-part-share v-if="showModalNumber" :codpart="pedv.codpart" @closeform="handleEnviaLinkWhats"></fones-part-share>

    </div>

</template>


<style>


.status-popover {
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    min-width: 200px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #00000033;
    box-shadow: 0 5px 10px #00000033;
    background-clip: padding-box;
}    

</style>



// WEBPACK FOOTER //
// src/forms/pedido-status-share.vue